import Items from '../data/ru-RU.json';

export default (state = Items) => {
    return state
}